"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var JoinOperator;
(function (JoinOperator) {
    JoinOperator["EQUALS"] = "EQUALS";
    JoinOperator["NOT_EQUALS"] = "NOT_EQUALS";
    JoinOperator["LESS_THAN"] = "LESS_THAN";
    JoinOperator["GREATER_THAN"] = "GREATER_THAN";
    JoinOperator["LESS_THAN_OR_EQUAL"] = "LESS_THAN_OR_EQUAL";
    JoinOperator["GREATER_THAN_OR_EQUAL"] = "GREATER_THAN_OR_EQUAL";
})(JoinOperator || (JoinOperator = {}));
exports.default = JoinOperator;
//# sourceMappingURL=JoinOperator.js.map


//////////////////
// WEBPACK FOOTER
// ../api/lib/abstract_query/interfaces/JoinOperator.js
// module id = 1578
// module chunks = 8